var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.quickTopicInfo.coverImgPc)?_c('div',{staticClass:"quick-topic-wrap"},[_c('img',{staticClass:"cover",attrs:{"src":_vm.quickTopicInfo.coverImgPc,"alt":_vm.quickTopicInfo.name},on:{"click":_vm.goToQuickTopic}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }